module.exports = __webpack_public_path__ + "static/media/3.1499a25f.jpg";